import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from "../../login/login.service";
import { SharedService } from "../shared/shared.service";
import { UserInfoService } from 'src/app/user-info/user-info.service';  //Modified by PP(2023-10-24): Check for timeout of logincode
import { isNullOrEmpty } from '../validation';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate {


  constructor(private router: Router,
    private loginService: LoginService,
    private httpService: HttpClient,
    private sharedService: SharedService,
    private activated: ActivatedRoute,
    private userInfoService: UserInfoService //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  webServiceUrl = SharedService.webServiceUrl;

  public checkRemainingSec: boolean = true;
  toValidateRemainSec: boolean = false;
  remainingSec: number = 0;

  //Modified by PP(2023-10-24): Check for timeout of logincode - START
  // canActivate(): boolean {
  //   let token = this.loginService.cookieSvc.get("CFSSLoginCode");
  //   return true;
  // }

  canActivate(): boolean {
    let token = this.loginService.cookieSvc.get("CFSSLoginCode");

    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld - START
    // if(!isNullOrEmpty(this.activated.snapshot.queryParams.AccessCode)) {
    //   if (token !== this.activated.snapshot.queryParams.AccessCode){
    //     token = this.activated.snapshot.queryParams.AccessCode;
    //     this.sharedService.token = token;
    //     this.loginService.cookieSvc.set("CFSSLoginCode", token);
    //   }
    // }
    //Modified by Pinky (2026-10-12) : Login from Central Station unable to come to mccld - END

    this.sharedService.checkValidLogin(token).subscribe(res => {
      if (res === true) {

      } else {
        this.sharedService.invalidLoginMessage = "Session time-out. Please login again.";
        this.loginService.cookieSvc.set("CFSSLoginCode", '');
        this.userInfoService.userData.UserId = 0;
        this.router.navigate(["login"]);
      }
    });
    return true;
  }
  //Modified by PP(2023-10-24): Check for timeout of logincode - END

  redirectToHome() {
    this.checkRemainingSec = false;
    this.router.navigate(["home"], { queryParams: { ApplicationID: this.sharedService.ApplicationID } });
  }

}


